/**
 * This file is generated by the ./scripts/hawkins-dgs/generate.ts script. Do not edit this file directly.
 */
export const Colors = {
    /**
     * rgb(218, 117, 22)
     */
    Amber: 'rgb(218, 117, 22)',
    /**
     * rgb(247, 235, 223)
     */
    Amber50: 'rgb(247, 235, 223)',
    /**
     * rgb(252, 218, 186)
     */
    Amber100: 'rgb(252, 218, 186)',
    /**
     * rgb(251, 196, 144)
     */
    Amber200: 'rgb(251, 196, 144)',
    /**
     * rgb(242, 171, 104)
     */
    Amber300: 'rgb(242, 171, 104)',
    /**
     * rgb(231, 144, 62)
     */
    Amber400: 'rgb(231, 144, 62)',
    /**
     * rgb(218, 117, 22)
     */
    Amber500: 'rgb(218, 117, 22)',
    /**
     * rgb(181, 96, 18)
     */
    Amber600: 'rgb(181, 96, 18)',
    /**
     * rgb(146, 85, 27)
     */
    Amber700: 'rgb(146, 85, 27)',
    /**
     * rgb(106, 65, 26)
     */
    Amber800: 'rgb(106, 65, 26)',
    /**
     * rgb(67, 44, 21)
     */
    Amber900: 'rgb(67, 44, 21)',
    /**
     * rgb(33, 23, 13)
     */
    Amber950: 'rgb(33, 23, 13)',
    /**
     * rgba(218, 117, 22, 0.0)
     */
    AmberT00: 'rgba(218, 117, 22, 0.0)',
    /**
     * rgba(218, 117, 22, 0.02)
     */
    AmberT02: 'rgba(218, 117, 22, 0.02)',
    /**
     * rgba(218, 117, 22, 0.04)
     */
    AmberT04: 'rgba(218, 117, 22, 0.04)',
    /**
     * rgba(218, 117, 22, 0.1)
     */
    AmberT10: 'rgba(218, 117, 22, 0.1)',
    /**
     * rgba(218, 117, 22, 0.2)
     */
    AmberT20: 'rgba(218, 117, 22, 0.2)',
    /**
     * rgba(218, 117, 22, 0.3)
     */
    AmberT30: 'rgba(218, 117, 22, 0.3)',
    /**
     * rgba(218, 117, 22, 0.4)
     */
    AmberT40: 'rgba(218, 117, 22, 0.4)',
    /**
     * rgba(218, 117, 22, 0.5)
     */
    AmberT50: 'rgba(218, 117, 22, 0.5)',
    /**
     * rgba(218, 117, 22, 0.6)
     */
    AmberT60: 'rgba(218, 117, 22, 0.6)',
    /**
     * rgba(218, 117, 22, 0.7)
     */
    AmberT70: 'rgba(218, 117, 22, 0.7)',
    /**
     * rgba(218, 117, 22, 0.8)
     */
    AmberT80: 'rgba(218, 117, 22, 0.8)',
    /**
     * rgba(218, 117, 22, 0.9)
     */
    AmberT90: 'rgba(218, 117, 22, 0.9)',
    /**
     * rgb(0, 0, 0)
     */
    Black: 'rgb(0, 0, 0)',
    /**
     * rgba(0, 0, 0, 0.0)
     */
    BlackT00: 'rgba(0, 0, 0, 0.0)',
    /**
     * rgba(0, 0, 0, 0.02)
     */
    BlackT02: 'rgba(0, 0, 0, 0.02)',
    /**
     * rgba(0, 0, 0, 0.04)
     */
    BlackT04: 'rgba(0, 0, 0, 0.04)',
    /**
     * rgba(0, 0, 0, 0.1)
     */
    BlackT10: 'rgba(0, 0, 0, 0.1)',
    /**
     * rgba(0, 0, 0, 0.2)
     */
    BlackT20: 'rgba(0, 0, 0, 0.2)',
    /**
     * rgba(0, 0, 0, 0.3)
     */
    BlackT30: 'rgba(0, 0, 0, 0.3)',
    /**
     * rgba(0, 0, 0, 0.4)
     */
    BlackT40: 'rgba(0, 0, 0, 0.4)',
    /**
     * rgba(0, 0, 0, 0.5)
     */
    BlackT50: 'rgba(0, 0, 0, 0.5)',
    /**
     * rgba(0, 0, 0, 0.6)
     */
    BlackT60: 'rgba(0, 0, 0, 0.6)',
    /**
     * rgba(0, 0, 0, 0.7)
     */
    BlackT70: 'rgba(0, 0, 0, 0.7)',
    /**
     * rgba(0, 0, 0, 0.8)
     */
    BlackT80: 'rgba(0, 0, 0, 0.8)',
    /**
     * rgba(0, 0, 0, 0.9)
     */
    BlackT90: 'rgba(0, 0, 0, 0.9)',
    /**
     * rgb(33, 114, 227)
     */
    Blue: 'rgb(33, 114, 227)',
    /**
     * rgb(223, 233, 247)
     */
    Blue50: 'rgb(223, 233, 247)',
    /**
     * rgb(188, 216, 255)
     */
    Blue100: 'rgb(188, 216, 255)',
    /**
     * rgb(148, 194, 255)
     */
    Blue200: 'rgb(148, 194, 255)',
    /**
     * rgb(105, 168, 255)
     */
    Blue300: 'rgb(105, 168, 255)',
    /**
     * rgb(68, 142, 244)
     */
    Blue400: 'rgb(68, 142, 244)',
    /**
     * rgb(33, 114, 227)
     */
    Blue500: 'rgb(33, 114, 227)',
    /**
     * rgb(29, 99, 196)
     */
    Blue600: 'rgb(29, 99, 196)',
    /**
     * rgb(29, 82, 157)
     */
    Blue700: 'rgb(29, 82, 157)',
    /**
     * rgb(28, 64, 114)
     */
    Blue800: 'rgb(28, 64, 114)',
    /**
     * rgb(23, 43, 71)
     */
    Blue900: 'rgb(23, 43, 71)',
    /**
     * rgb(13, 22, 33)
     */
    Blue950: 'rgb(13, 22, 33)',
    /**
     * rgba(33, 114, 227, 0.0)
     */
    BlueT00: 'rgba(33, 114, 227, 0.0)',
    /**
     * rgba(33, 114, 227, 0.02)
     */
    BlueT02: 'rgba(33, 114, 227, 0.02)',
    /**
     * rgba(33, 114, 227, 0.04)
     */
    BlueT04: 'rgba(33, 114, 227, 0.04)',
    /**
     * rgba(33, 114, 227, 0.1)
     */
    BlueT10: 'rgba(33, 114, 227, 0.1)',
    /**
     * rgba(33, 114, 227, 0.2)
     */
    BlueT20: 'rgba(33, 114, 227, 0.2)',
    /**
     * rgba(33, 114, 227, 0.3)
     */
    BlueT30: 'rgba(33, 114, 227, 0.3)',
    /**
     * rgba(33, 114, 227, 0.4)
     */
    BlueT40: 'rgba(33, 114, 227, 0.4)',
    /**
     * rgba(33, 114, 227, 0.5)
     */
    BlueT50: 'rgba(33, 114, 227, 0.5)',
    /**
     * rgba(33, 114, 227, 0.6)
     */
    BlueT60: 'rgba(33, 114, 227, 0.6)',
    /**
     * rgba(33, 114, 227, 0.7)
     */
    BlueT70: 'rgba(33, 114, 227, 0.7)',
    /**
     * rgba(33, 114, 227, 0.8)
     */
    BlueT80: 'rgba(33, 114, 227, 0.8)',
    /**
     * rgba(33, 114, 227, 0.9)
     */
    BlueT90: 'rgba(33, 114, 227, 0.9)',
    /**
     * rgb(28, 159, 171)
     */
    Cyan: 'rgb(28, 159, 171)',
    /**
     * rgb(209, 235, 237)
     */
    Cyan50: 'rgb(209, 235, 237)',
    /**
     * rgb(175, 225, 230)
     */
    Cyan100: 'rgb(175, 225, 230)',
    /**
     * rgb(138, 213, 220)
     */
    Cyan200: 'rgb(138, 213, 220)',
    /**
     * rgb(100, 197, 206)
     */
    Cyan300: 'rgb(100, 197, 206)',
    /**
     * rgb(65, 177, 186)
     */
    Cyan400: 'rgb(65, 177, 186)',
    /**
     * rgb(28, 159, 171)
     */
    Cyan500: 'rgb(28, 159, 171)',
    /**
     * rgb(22, 131, 141)
     */
    Cyan600: 'rgb(22, 131, 141)',
    /**
     * rgb(25, 111, 119)
     */
    Cyan700: 'rgb(25, 111, 119)',
    /**
     * rgb(23, 82, 87)
     */
    Cyan800: 'rgb(23, 82, 87)',
    /**
     * rgb(19, 54, 57)
     */
    Cyan900: 'rgb(19, 54, 57)',
    /**
     * rgb(12, 29, 31)
     */
    Cyan950: 'rgb(12, 29, 31)',
    /**
     * rgba(28, 159, 171, 0.0)
     */
    CyanT00: 'rgba(28, 159, 171, 0.0)',
    /**
     * rgba(28, 159, 171, 0.02)
     */
    CyanT02: 'rgba(28, 159, 171, 0.02)',
    /**
     * rgba(28, 159, 171, 0.04)
     */
    CyanT04: 'rgba(28, 159, 171, 0.04)',
    /**
     * rgba(28, 159, 171, 0.1)
     */
    CyanT10: 'rgba(28, 159, 171, 0.1)',
    /**
     * rgba(28, 159, 171, 0.2)
     */
    CyanT20: 'rgba(28, 159, 171, 0.2)',
    /**
     * rgba(28, 159, 171, 0.3)
     */
    CyanT30: 'rgba(28, 159, 171, 0.3)',
    /**
     * rgba(28, 159, 171, 0.4)
     */
    CyanT40: 'rgba(28, 159, 171, 0.4)',
    /**
     * rgba(28, 159, 171, 0.5)
     */
    CyanT50: 'rgba(28, 159, 171, 0.5)',
    /**
     * rgba(28, 159, 171, 0.6)
     */
    CyanT60: 'rgba(28, 159, 171, 0.6)',
    /**
     * rgba(28, 159, 171, 0.7)
     */
    CyanT70: 'rgba(28, 159, 171, 0.7)',
    /**
     * rgba(28, 159, 171, 0.8)
     */
    CyanT80: 'rgba(28, 159, 171, 0.8)',
    /**
     * rgba(28, 159, 171, 0.9)
     */
    CyanT90: 'rgba(28, 159, 171, 0.9)',
    /**
     * rgb(128, 128, 128)
     */
    Gray: 'rgb(128, 128, 128)',
    /**
     * rgb(250, 250, 250)
     */
    Gray50: 'rgb(250, 250, 250)',
    /**
     * rgb(242, 242, 242)
     */
    Gray100: 'rgb(242, 242, 242)',
    /**
     * rgb(229, 229, 229)
     */
    Gray200: 'rgb(229, 229, 229)',
    /**
     * rgb(214, 214, 214)
     */
    Gray300: 'rgb(214, 214, 214)',
    /**
     * rgb(196, 196, 196)
     */
    Gray400: 'rgb(196, 196, 196)',
    /**
     * rgb(128, 128, 128)
     */
    Gray500: 'rgb(128, 128, 128)',
    /**
     * rgb(65, 65, 65)
     */
    Gray600: 'rgb(65, 65, 65)',
    /**
     * rgb(45, 45, 45)
     */
    Gray700: 'rgb(45, 45, 45)',
    /**
     * rgb(35, 35, 35)
     */
    Gray800: 'rgb(35, 35, 35)',
    /**
     * rgb(22, 22, 22)
     */
    Gray900: 'rgb(22, 22, 22)',
    /**
     * rgb(15, 15, 15)
     */
    Gray950: 'rgb(15, 15, 15)',
    /**
     * rgba(128, 128, 128, 0.0)
     */
    GrayT00: 'rgba(128, 128, 128, 0.0)',
    /**
     * rgba(128, 128, 128, 0.02)
     */
    GrayT02: 'rgba(128, 128, 128, 0.02)',
    /**
     * rgba(128, 128, 128, 0.04)
     */
    GrayT04: 'rgba(128, 128, 128, 0.04)',
    /**
     * rgba(128, 128, 128, 0.1)
     */
    GrayT10: 'rgba(128, 128, 128, 0.1)',
    /**
     * rgba(128, 128, 128, 0.2)
     */
    GrayT20: 'rgba(128, 128, 128, 0.2)',
    /**
     * rgba(128, 128, 128, 0.3)
     */
    GrayT30: 'rgba(128, 128, 128, 0.3)',
    /**
     * rgba(128, 128, 128, 0.4)
     */
    GrayT40: 'rgba(128, 128, 128, 0.4)',
    /**
     * rgba(128, 128, 128, 0.5)
     */
    GrayT50: 'rgba(128, 128, 128, 0.5)',
    /**
     * rgba(128, 128, 128, 0.6)
     */
    GrayT60: 'rgba(128, 128, 128, 0.6)',
    /**
     * rgba(128, 128, 128, 0.7)
     */
    GrayT70: 'rgba(128, 128, 128, 0.7)',
    /**
     * rgba(128, 128, 128, 0.8)
     */
    GrayT80: 'rgba(128, 128, 128, 0.8)',
    /**
     * rgba(128, 128, 128, 0.9)
     */
    GrayT90: 'rgba(128, 128, 128, 0.9)',
    /**
     * rgb(10, 163, 86)
     */
    Green: 'rgb(10, 163, 86)',
    /**
     * rgb(222, 245, 234)
     */
    Green50: 'rgb(222, 245, 234)',
    /**
     * rgb(178, 237, 207)
     */
    Green100: 'rgb(178, 237, 207)',
    /**
     * rgb(132, 223, 178)
     */
    Green200: 'rgb(132, 223, 178)',
    /**
     * rgb(82, 200, 141)
     */
    Green300: 'rgb(82, 200, 141)',
    /**
     * rgb(43, 184, 113)
     */
    Green400: 'rgb(43, 184, 113)',
    /**
     * rgb(10, 163, 86)
     */
    Green500: 'rgb(10, 163, 86)',
    /**
     * rgb(12, 136, 73)
     */
    Green600: 'rgb(12, 136, 73)',
    /**
     * rgb(16, 113, 64)
     */
    Green700: 'rgb(16, 113, 64)',
    /**
     * rgb(17, 84, 50)
     */
    Green800: 'rgb(17, 84, 50)',
    /**
     * rgb(15, 56, 36)
     */
    Green900: 'rgb(15, 56, 36)',
    /**
     * rgb(11, 33, 22)
     */
    Green950: 'rgb(11, 33, 22)',
    /**
     * rgba(10, 163, 86, 0.0)
     */
    GreenT00: 'rgba(10, 163, 86, 0.0)',
    /**
     * rgba(10, 163, 86, 0.02)
     */
    GreenT02: 'rgba(10, 163, 86, 0.02)',
    /**
     * rgba(10, 163, 86, 0.04)
     */
    GreenT04: 'rgba(10, 163, 86, 0.04)',
    /**
     * rgba(10, 163, 86, 0.1)
     */
    GreenT10: 'rgba(10, 163, 86, 0.1)',
    /**
     * rgba(10, 163, 86, 0.2)
     */
    GreenT20: 'rgba(10, 163, 86, 0.2)',
    /**
     * rgba(10, 163, 86, 0.3)
     */
    GreenT30: 'rgba(10, 163, 86, 0.3)',
    /**
     * rgba(10, 163, 86, 0.4)
     */
    GreenT40: 'rgba(10, 163, 86, 0.4)',
    /**
     * rgba(10, 163, 86, 0.5)
     */
    GreenT50: 'rgba(10, 163, 86, 0.5)',
    /**
     * rgba(10, 163, 86, 0.6)
     */
    GreenT60: 'rgba(10, 163, 86, 0.6)',
    /**
     * rgba(10, 163, 86, 0.7)
     */
    GreenT70: 'rgba(10, 163, 86, 0.7)',
    /**
     * rgba(10, 163, 86, 0.8)
     */
    GreenT80: 'rgba(10, 163, 86, 0.8)',
    /**
     * rgba(10, 163, 86, 0.9)
     */
    GreenT90: 'rgba(10, 163, 86, 0.9)',
    /**
     * rgb(64, 97, 231)
     */
    Indigo: 'rgb(64, 97, 231)',
    /**
     * rgb(225, 229, 245)
     */
    Indigo50: 'rgb(225, 229, 245)',
    /**
     * rgb(199, 210, 252)
     */
    Indigo100: 'rgb(199, 210, 252)',
    /**
     * rgb(169, 185, 250)
     */
    Indigo200: 'rgb(169, 185, 250)',
    /**
     * rgb(136, 159, 249)
     */
    Indigo300: 'rgb(136, 159, 249)',
    /**
     * rgb(91, 121, 241)
     */
    Indigo400: 'rgb(91, 121, 241)',
    /**
     * rgb(64, 97, 231)
     */
    Indigo500: 'rgb(64, 97, 231)',
    /**
     * rgb(52, 81, 197)
     */
    Indigo600: 'rgb(52, 81, 197)',
    /**
     * rgb(44, 66, 156)
     */
    Indigo700: 'rgb(44, 66, 156)',
    /**
     * rgb(35, 51, 113)
     */
    Indigo800: 'rgb(35, 51, 113)',
    /**
     * rgb(25, 34, 71)
     */
    Indigo900: 'rgb(25, 34, 71)',
    /**
     * rgb(13, 17, 33)
     */
    Indigo950: 'rgb(13, 17, 33)',
    /**
     * rgba(64, 97, 231, 0.0)
     */
    IndigoT00: 'rgba(64, 97, 231, 0.0)',
    /**
     * rgba(64, 97, 231, 0.02)
     */
    IndigoT02: 'rgba(64, 97, 231, 0.02)',
    /**
     * rgba(64, 97, 231, 0.04)
     */
    IndigoT04: 'rgba(64, 97, 231, 0.04)',
    /**
     * rgba(64, 97, 231, 0.1)
     */
    IndigoT10: 'rgba(64, 97, 231, 0.1)',
    /**
     * rgba(64, 97, 231, 0.2)
     */
    IndigoT20: 'rgba(64, 97, 231, 0.2)',
    /**
     * rgba(64, 97, 231, 0.3)
     */
    IndigoT30: 'rgba(64, 97, 231, 0.3)',
    /**
     * rgba(64, 97, 231, 0.4)
     */
    IndigoT40: 'rgba(64, 97, 231, 0.4)',
    /**
     * rgba(64, 97, 231, 0.5)
     */
    IndigoT50: 'rgba(64, 97, 231, 0.5)',
    /**
     * rgba(64, 97, 231, 0.6)
     */
    IndigoT60: 'rgba(64, 97, 231, 0.6)',
    /**
     * rgba(64, 97, 231, 0.7)
     */
    IndigoT70: 'rgba(64, 97, 231, 0.7)',
    /**
     * rgba(64, 97, 231, 0.8)
     */
    IndigoT80: 'rgba(64, 97, 231, 0.8)',
    /**
     * rgba(64, 97, 231, 0.9)
     */
    IndigoT90: 'rgba(64, 97, 231, 0.9)',
    /**
     * rgb(219, 91, 36)
     */
    Orange: 'rgb(219, 91, 36)',
    /**
     * rgb(247, 230, 223)
     */
    Orange50: 'rgb(247, 230, 223)',
    /**
     * rgb(255, 208, 187)
     */
    Orange100: 'rgb(255, 208, 187)',
    /**
     * rgb(251, 182, 152)
     */
    Orange200: 'rgb(251, 182, 152)',
    /**
     * rgb(247, 151, 110)
     */
    Orange300: 'rgb(247, 151, 110)',
    /**
     * rgb(239, 119, 68)
     */
    Orange400: 'rgb(239, 119, 68)',
    /**
     * rgb(219, 91, 36)
     */
    Orange500: 'rgb(219, 91, 36)',
    /**
     * rgb(193, 77, 28)
     */
    Orange600: 'rgb(193, 77, 28)',
    /**
     * rgb(153, 66, 29)
     */
    Orange700: 'rgb(153, 66, 29)',
    /**
     * rgb(111, 53, 28)
     */
    Orange800: 'rgb(111, 53, 28)',
    /**
     * rgb(70, 37, 22)
     */
    Orange900: 'rgb(70, 37, 22)',
    /**
     * rgb(33, 19, 13)
     */
    Orange950: 'rgb(33, 19, 13)',
    /**
     * rgba(219, 91, 36, 0.0)
     */
    OrangeT00: 'rgba(219, 91, 36, 0.0)',
    /**
     * rgba(219, 91, 36, 0.02)
     */
    OrangeT02: 'rgba(219, 91, 36, 0.02)',
    /**
     * rgba(219, 91, 36, 0.04)
     */
    OrangeT04: 'rgba(219, 91, 36, 0.04)',
    /**
     * rgba(219, 91, 36, 0.1)
     */
    OrangeT10: 'rgba(219, 91, 36, 0.1)',
    /**
     * rgba(219, 91, 36, 0.2)
     */
    OrangeT20: 'rgba(219, 91, 36, 0.2)',
    /**
     * rgba(219, 91, 36, 0.3)
     */
    OrangeT30: 'rgba(219, 91, 36, 0.3)',
    /**
     * rgba(219, 91, 36, 0.4)
     */
    OrangeT40: 'rgba(219, 91, 36, 0.4)',
    /**
     * rgba(219, 91, 36, 0.5)
     */
    OrangeT50: 'rgba(219, 91, 36, 0.5)',
    /**
     * rgba(219, 91, 36, 0.6)
     */
    OrangeT60: 'rgba(219, 91, 36, 0.6)',
    /**
     * rgba(219, 91, 36, 0.7)
     */
    OrangeT70: 'rgba(219, 91, 36, 0.7)',
    /**
     * rgba(219, 91, 36, 0.8)
     */
    OrangeT80: 'rgba(219, 91, 36, 0.8)',
    /**
     * rgba(219, 91, 36, 0.9)
     */
    OrangeT90: 'rgba(219, 91, 36, 0.9)',
    /**
     * rgb(211, 49, 122)
     */
    Pink: 'rgb(211, 49, 122)',
    /**
     * rgb(245, 225, 234)
     */
    Pink50: 'rgb(245, 225, 234)',
    /**
     * rgb(246, 197, 219)
     */
    Pink100: 'rgb(246, 197, 219)',
    /**
     * rgb(248, 157, 198)
     */
    Pink200: 'rgb(248, 157, 198)',
    /**
     * rgb(242, 118, 174)
     */
    Pink300: 'rgb(242, 118, 174)',
    /**
     * rgb(231, 80, 148)
     */
    Pink400: 'rgb(231, 80, 148)',
    /**
     * rgb(211, 49, 122)
     */
    Pink500: 'rgb(211, 49, 122)',
    /**
     * rgb(184, 40, 105)
     */
    Pink600: 'rgb(184, 40, 105)',
    /**
     * rgb(146, 37, 86)
     */
    Pink700: 'rgb(146, 37, 86)',
    /**
     * rgb(108, 30, 65)
     */
    Pink800: 'rgb(108, 30, 65)',
    /**
     * rgb(69, 23, 43)
     */
    Pink900: 'rgb(69, 23, 43)',
    /**
     * rgb(33, 13, 22)
     */
    Pink950: 'rgb(33, 13, 22)',
    /**
     * rgba(211, 49, 122, 0.0)
     */
    PinkT00: 'rgba(211, 49, 122, 0.0)',
    /**
     * rgba(211, 49, 122, 0.02)
     */
    PinkT02: 'rgba(211, 49, 122, 0.02)',
    /**
     * rgba(211, 49, 122, 0.04)
     */
    PinkT04: 'rgba(211, 49, 122, 0.04)',
    /**
     * rgba(211, 49, 122, 0.1)
     */
    PinkT10: 'rgba(211, 49, 122, 0.1)',
    /**
     * rgba(211, 49, 122, 0.2)
     */
    PinkT20: 'rgba(211, 49, 122, 0.2)',
    /**
     * rgba(211, 49, 122, 0.3)
     */
    PinkT30: 'rgba(211, 49, 122, 0.3)',
    /**
     * rgba(211, 49, 122, 0.4)
     */
    PinkT40: 'rgba(211, 49, 122, 0.4)',
    /**
     * rgba(211, 49, 122, 0.5)
     */
    PinkT50: 'rgba(211, 49, 122, 0.5)',
    /**
     * rgba(211, 49, 122, 0.6)
     */
    PinkT60: 'rgba(211, 49, 122, 0.6)',
    /**
     * rgba(211, 49, 122, 0.7)
     */
    PinkT70: 'rgba(211, 49, 122, 0.7)',
    /**
     * rgba(211, 49, 122, 0.8)
     */
    PinkT80: 'rgba(211, 49, 122, 0.8)',
    /**
     * rgba(211, 49, 122, 0.9)
     */
    PinkT90: 'rgba(211, 49, 122, 0.9)',
    /**
     * rgb(176, 56, 220)
     */
    Purple: 'rgb(176, 56, 220)',
    /**
     * rgb(240, 225, 245)
     */
    Purple50: 'rgb(240, 225, 245)',
    /**
     * rgb(236, 195, 251)
     */
    Purple100: 'rgb(236, 195, 251)',
    /**
     * rgb(228, 161, 250)
     */
    Purple200: 'rgb(228, 161, 250)',
    /**
     * rgb(214, 125, 247)
     */
    Purple300: 'rgb(214, 125, 247)',
    /**
     * rgb(201, 79, 245)
     */
    Purple400: 'rgb(201, 79, 245)',
    /**
     * rgb(176, 56, 220)
     */
    Purple500: 'rgb(176, 56, 220)',
    /**
     * rgb(152, 45, 190)
     */
    Purple600: 'rgb(152, 45, 190)',
    /**
     * rgb(121, 42, 149)
     */
    Purple700: 'rgb(121, 42, 149)',
    /**
     * rgb(89, 33, 110)
     */
    Purple800: 'rgb(89, 33, 110)',
    /**
     * rgb(57, 25, 69)
     */
    Purple900: 'rgb(57, 25, 69)',
    /**
     * rgb(28, 14, 32)
     */
    Purple950: 'rgb(28, 14, 32)',
    /**
     * rgba(176, 56, 220, 0.0)
     */
    PurpleT00: 'rgba(176, 56, 220, 0.0)',
    /**
     * rgba(176, 56, 220, 0.02)
     */
    PurpleT02: 'rgba(176, 56, 220, 0.02)',
    /**
     * rgba(176, 56, 220, 0.04)
     */
    PurpleT04: 'rgba(176, 56, 220, 0.04)',
    /**
     * rgba(176, 56, 220, 0.1)
     */
    PurpleT10: 'rgba(176, 56, 220, 0.1)',
    /**
     * rgba(176, 56, 220, 0.2)
     */
    PurpleT20: 'rgba(176, 56, 220, 0.2)',
    /**
     * rgba(176, 56, 220, 0.3)
     */
    PurpleT30: 'rgba(176, 56, 220, 0.3)',
    /**
     * rgba(176, 56, 220, 0.4)
     */
    PurpleT40: 'rgba(176, 56, 220, 0.4)',
    /**
     * rgba(176, 56, 220, 0.5)
     */
    PurpleT50: 'rgba(176, 56, 220, 0.5)',
    /**
     * rgba(176, 56, 220, 0.6)
     */
    PurpleT60: 'rgba(176, 56, 220, 0.6)',
    /**
     * rgba(176, 56, 220, 0.7)
     */
    PurpleT70: 'rgba(176, 56, 220, 0.7)',
    /**
     * rgba(176, 56, 220, 0.8)
     */
    PurpleT80: 'rgba(176, 56, 220, 0.8)',
    /**
     * rgba(176, 56, 220, 0.9)
     */
    PurpleT90: 'rgba(176, 56, 220, 0.9)',
    /**
     * rgb(229, 9, 20)
     */
    Red: 'rgb(229, 9, 20)',
    /**
     * rgb(245, 225, 226)
     */
    Red50: 'rgb(245, 225, 226)',
    /**
     * rgb(250, 188, 191)
     */
    Red100: 'rgb(250, 188, 191)',
    /**
     * rgb(249, 146, 151)
     */
    Red200: 'rgb(249, 146, 151)',
    /**
     * rgb(247, 99, 107)
     */
    Red300: 'rgb(247, 99, 107)',
    /**
     * rgb(235, 57, 66)
     */
    Red400: 'rgb(235, 57, 66)',
    /**
     * rgb(229, 9, 20)
     */
    Red500: 'rgb(229, 9, 20)',
    /**
     * rgb(193, 17, 25)
     */
    Red600: 'rgb(193, 17, 25)',
    /**
     * rgb(153, 22, 29)
     */
    Red700: 'rgb(153, 22, 29)',
    /**
     * rgb(111, 24, 29)
     */
    Red800: 'rgb(111, 24, 29)',
    /**
     * rgb(70, 21, 24)
     */
    Red900: 'rgb(70, 21, 24)',
    /**
     * rgb(33, 13, 14)
     */
    Red950: 'rgb(33, 13, 14)',
    /**
     * rgba(229, 9, 20, 0.0)
     */
    RedT00: 'rgba(229, 9, 20, 0.0)',
    /**
     * rgba(229, 9, 20, 0.02)
     */
    RedT02: 'rgba(229, 9, 20, 0.02)',
    /**
     * rgba(229, 9, 20, 0.04)
     */
    RedT04: 'rgba(229, 9, 20, 0.04)',
    /**
     * rgba(229, 9, 20, 0.1)
     */
    RedT10: 'rgba(229, 9, 20, 0.1)',
    /**
     * rgba(229, 9, 20, 0.2)
     */
    RedT20: 'rgba(229, 9, 20, 0.2)',
    /**
     * rgba(229, 9, 20, 0.3)
     */
    RedT30: 'rgba(229, 9, 20, 0.3)',
    /**
     * rgba(229, 9, 20, 0.4)
     */
    RedT40: 'rgba(229, 9, 20, 0.4)',
    /**
     * rgba(229, 9, 20, 0.5)
     */
    RedT50: 'rgba(229, 9, 20, 0.5)',
    /**
     * rgba(229, 9, 20, 0.6)
     */
    RedT60: 'rgba(229, 9, 20, 0.6)',
    /**
     * rgba(229, 9, 20, 0.7)
     */
    RedT70: 'rgba(229, 9, 20, 0.7)',
    /**
     * rgba(229, 9, 20, 0.8)
     */
    RedT80: 'rgba(229, 9, 20, 0.8)',
    /**
     * rgba(229, 9, 20, 0.9)
     */
    RedT90: 'rgba(229, 9, 20, 0.9)',
    /**
     * rgba(0, 0, 0, 0)
     */
    Transparent: 'rgba(0, 0, 0, 0)',
    /**
     * rgb(109, 59, 227)
     */
    Violet: 'rgb(109, 59, 227)',
    /**
     * rgb(228, 220, 245)
     */
    Violet50: 'rgb(228, 220, 245)',
    /**
     * rgb(211, 194, 251)
     */
    Violet100: 'rgb(211, 194, 251)',
    /**
     * rgb(189, 161, 253)
     */
    Violet200: 'rgb(189, 161, 253)',
    /**
     * rgb(163, 126, 250)
     */
    Violet300: 'rgb(163, 126, 250)',
    /**
     * rgb(136, 91, 241)
     */
    Violet400: 'rgb(136, 91, 241)',
    /**
     * rgb(109, 59, 227)
     */
    Violet500: 'rgb(109, 59, 227)',
    /**
     * rgb(92, 50, 191)
     */
    Violet600: 'rgb(92, 50, 191)',
    /**
     * rgb(74, 42, 150)
     */
    Violet700: 'rgb(74, 42, 150)',
    /**
     * rgb(56, 33, 108)
     */
    Violet800: 'rgb(56, 33, 108)',
    /**
     * rgb(37, 23, 67)
     */
    Violet900: 'rgb(37, 23, 67)',
    /**
     * rgb(18, 12, 31)
     */
    Violet950: 'rgb(18, 12, 31)',
    /**
     * rgba(109, 59, 227, 0.0)
     */
    VioletT00: 'rgba(109, 59, 227, 0.0)',
    /**
     * rgba(109, 59, 227, 0.02)
     */
    VioletT02: 'rgba(109, 59, 227, 0.02)',
    /**
     * rgba(109, 59, 227, 0.04)
     */
    VioletT04: 'rgba(109, 59, 227, 0.04)',
    /**
     * rgba(109, 59, 227, 0.1)
     */
    VioletT10: 'rgba(109, 59, 227, 0.1)',
    /**
     * rgba(109, 59, 227, 0.2)
     */
    VioletT20: 'rgba(109, 59, 227, 0.2)',
    /**
     * rgba(109, 59, 227, 0.3)
     */
    VioletT30: 'rgba(109, 59, 227, 0.3)',
    /**
     * rgba(109, 59, 227, 0.4)
     */
    VioletT40: 'rgba(109, 59, 227, 0.4)',
    /**
     * rgba(109, 59, 227, 0.5)
     */
    VioletT50: 'rgba(109, 59, 227, 0.5)',
    /**
     * rgba(109, 59, 227, 0.6)
     */
    VioletT60: 'rgba(109, 59, 227, 0.6)',
    /**
     * rgba(109, 59, 227, 0.7)
     */
    VioletT70: 'rgba(109, 59, 227, 0.7)',
    /**
     * rgba(109, 59, 227, 0.8)
     */
    VioletT80: 'rgba(109, 59, 227, 0.8)',
    /**
     * rgba(109, 59, 227, 0.9)
     */
    VioletT90: 'rgba(109, 59, 227, 0.9)',
    /**
     * rgb(255, 255, 255)
     */
    White: 'rgb(255, 255, 255)',
    /**
     * rgba(255, 255, 255, 0.0)
     */
    WhiteT00: 'rgba(255, 255, 255, 0.0)',
    /**
     * rgba(255, 255, 255, 0.02)
     */
    WhiteT02: 'rgba(255, 255, 255, 0.02)',
    /**
     * rgba(255, 255, 255, 0.04)
     */
    WhiteT04: 'rgba(255, 255, 255, 0.04)',
    /**
     * rgba(255, 255, 255, 0.1)
     */
    WhiteT10: 'rgba(255, 255, 255, 0.1)',
    /**
     * rgba(255, 255, 255, 0.2)
     */
    WhiteT20: 'rgba(255, 255, 255, 0.2)',
    /**
     * rgba(255, 255, 255, 0.3)
     */
    WhiteT30: 'rgba(255, 255, 255, 0.3)',
    /**
     * rgba(255, 255, 255, 0.4)
     */
    WhiteT40: 'rgba(255, 255, 255, 0.4)',
    /**
     * rgba(255, 255, 255, 0.5)
     */
    WhiteT50: 'rgba(255, 255, 255, 0.5)',
    /**
     * rgba(255, 255, 255, 0.6)
     */
    WhiteT60: 'rgba(255, 255, 255, 0.6)',
    /**
     * rgba(255, 255, 255, 0.7)
     */
    WhiteT70: 'rgba(255, 255, 255, 0.7)',
    /**
     * rgba(255, 255, 255, 0.8)
     */
    WhiteT80: 'rgba(255, 255, 255, 0.8)',
    /**
     * rgba(255, 255, 255, 0.9)
     */
    WhiteT90: 'rgba(255, 255, 255, 0.9)',
    /**
     * rgb(195, 131, 14)
     */
    Yellow: 'rgb(195, 131, 14)',
    /**
     * rgb(247, 239, 223)
     */
    Yellow50: 'rgb(247, 239, 223)',
    /**
     * rgb(247, 224, 181)
     */
    Yellow100: 'rgb(247, 224, 181)',
    /**
     * rgb(242, 205, 136)
     */
    Yellow200: 'rgb(242, 205, 136)',
    /**
     * rgb(229, 181, 93)
     */
    Yellow300: 'rgb(229, 181, 93)',
    /**
     * rgb(216, 157, 49)
     */
    Yellow400: 'rgb(216, 157, 49)',
    /**
     * rgb(195, 131, 14)
     */
    Yellow500: 'rgb(195, 131, 14)',
    /**
     * rgb(159, 108, 15)
     */
    Yellow600: 'rgb(159, 108, 15)',
    /**
     * rgb(132, 93, 22)
     */
    Yellow700: 'rgb(132, 93, 22)',
    /**
     * rgb(97, 71, 23)
     */
    Yellow800: 'rgb(97, 71, 23)',
    /**
     * rgb(63, 48, 20)
     */
    Yellow900: 'rgb(63, 48, 20)',
    /**
     * rgb(33, 26, 13)
     */
    Yellow950: 'rgb(33, 26, 13)',
    /**
     * rgba(195, 131, 14, 0.0)
     */
    YellowT00: 'rgba(195, 131, 14, 0.0)',
    /**
     * rgba(195, 131, 14, 0.02)
     */
    YellowT02: 'rgba(195, 131, 14, 0.02)',
    /**
     * rgba(195, 131, 14, 0.04)
     */
    YellowT04: 'rgba(195, 131, 14, 0.04)',
    /**
     * rgba(195, 131, 14, 0.1)
     */
    YellowT10: 'rgba(195, 131, 14, 0.1)',
    /**
     * rgba(195, 131, 14, 0.2)
     */
    YellowT20: 'rgba(195, 131, 14, 0.2)',
    /**
     * rgba(195, 131, 14, 0.3)
     */
    YellowT30: 'rgba(195, 131, 14, 0.3)',
    /**
     * rgba(195, 131, 14, 0.4)
     */
    YellowT40: 'rgba(195, 131, 14, 0.4)',
    /**
     * rgba(195, 131, 14, 0.5)
     */
    YellowT50: 'rgba(195, 131, 14, 0.5)',
    /**
     * rgba(195, 131, 14, 0.6)
     */
    YellowT60: 'rgba(195, 131, 14, 0.6)',
    /**
     * rgba(195, 131, 14, 0.7)
     */
    YellowT70: 'rgba(195, 131, 14, 0.7)',
    /**
     * rgba(195, 131, 14, 0.8)
     */
    YellowT80: 'rgba(195, 131, 14, 0.8)',
    /**
     * rgba(195, 131, 14, 0.9)
     */
    YellowT90: 'rgba(195, 131, 14, 0.9)',
};
//# sourceMappingURL=colors.variables.js.map